
    <div class="document-download-container">
        <div class="document-checkbox-container">
            <mat-checkbox
                [formControl]="documentControl"
                [disabled]="isDownloading || hasDownloadError"
                (change)="onCheckboxChange($event)"
                data-automation-id="checkbox_agree_to_compulsory_document"
            >
                <span [ngStyle]="textStyles">
                    {{ checkboxText }}
                    <a
                        (click)="onDocumentLinkClick($event)"
                        [class.disabled]="isDownloading"
                        class="m-0 text-[14px]"
                        data-automation-id="button_download_compulsory_document"
                    >{{ isDownloading ? downloadingText : downloadText }}</a>
                    {{ documentName }}
                </span>
            </mat-checkbox>

            <div *ngIf="isDownloading" class="loading-indicator">
                <mat-spinner diameter="20"></mat-spinner>
            </div>
        </div>

        <div class="error-container"  *ngIf="hasDownloadError" [ngStyle]="textStyles">
            <mat-error>Failed to download the document</mat-error>
        </div>

        <div class="error-container" *ngIf="(documentControl.dirty || documentControl.touched) && documentControl.errors?.required" [ngStyle]="textStyles">
            <mat-error data-automation-id="download_compulsory_document_text">Please download and read the document.</mat-error>
        </div>
    </div>